const domain: string = 'REQUESTS'

export const SAVE_REQUESTS: string = `${domain}/SAVE_REQUESTS`
